import React from "react";
import { factLabel, valueLabel } from "./proveFactLabels";

const stateLabels = { true: "충족", false: "충족하지 않음", unknown: "미확인", conflict: "충돌", not_evaluated: "앞 조건 확인 후 평가", not_applicable: "적용 대상 아님" };
const safeUrl = (value) => { try { const u = new URL(value); return u.protocol === "https:" ? u.href : null; } catch { return null; } };
const displayValue = (value, key) => value == null ? "미입력" : typeof value === "object"
  ? `${value.value ?? ""} ${value.unit ?? ""}`.trim() : valueLabel(value, key);
function expectedText(row) {
  const expected = row.expected || {};
  const enumValues = expected.allowed || expected.denied;
  if (enumValues) return `${expected.denied ? "제외 값" : "허용 값"}: ${enumValues.map((v) => valueLabel(v, row.fact_key)).join(" · ")}`;
  const signs = { number_gt: ">", number_gte: "≥", number_lt: "<", number_lte: "≤" };
  return expected.threshold != null ? `${signs[row.operator] || "기준"} ${expected.threshold} ${expected.unit || ""}` : "검수된 적용 조건";
}
function ConditionRows({ rows }) {
  return <div style={{ overflowX: "auto" }}><table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
    <thead><tr>{["확인 조건", "계산에 사용한 값", "결과·근거"].map((v) => <th key={v} style={{ textAlign: "left", padding: 8 }}>{v}</th>)}</tr></thead>
    <tbody>{rows.map((row, index) => <tr key={`${row.condition_id}-${index}`} style={{ borderTop: "1px solid var(--audit-border, #e5e7eb)" }}>
      <td style={{ padding: 8, verticalAlign: "top" }}>{row.label || factLabel(row.fact_key)}<br /><small>{expectedText(row)}</small></td>
      <td style={{ padding: 8, verticalAlign: "top" }}>{Object.entries(row.inputs || {}).map(([key, value]) => <div key={key}>{row.input_labels?.[key] || factLabel(key)}: {displayValue(value, key)}</div>)}</td>
      <td style={{ padding: 8, verticalAlign: "top", minWidth: 120 }}><strong>{stateLabels[row.state] || "미확인"}</strong><br />
        {safeUrl(row.source_url) ? <a href={safeUrl(row.source_url)} target="_blank" rel="noreferrer">{row.source_ref || "원문"}</a> : row.source_ref || "원문 연결 필요"}
        {row.source_precision === "chapter_context" && <small style={{ display: "block" }}>류 원문 참조 · 개별 조항 연결 전</small>}
      </td>
    </tr>)}</tbody>
  </table></div>;
}
export default function DecisionConditions({ tree }) {
  return ['juice','milling','food_preparation'].includes(tree?.product_fact_dialogue?.product_intake?.kind)
    ? <details style={{marginTop:12}}><summary>분류 규칙의 상세 계산 기록</summary><DecisionConditionsContent tree={tree} /></details>
    : <DecisionConditionsContent tree={tree} />;
}
function DecisionConditionsContent({ tree }) {
  const rows = Array.isArray(tree?.decision_trace) ? tree.decision_trace : [];
  const candidates = Array.isArray(tree?.factual_candidates) ? tree.factual_candidates : [];
  if (!rows.length && !candidates.length) return null;
  return <section aria-label="조건별 판정 근거" style={{ padding: "12px 14px", fontSize: 12, lineHeight: 1.6 }}>
    <strong>조건별 판정 근거</strong>
    <p style={{ margin: "4px 0 8px" }}>{tree?.observable_derivation
      ? '상품 답변에서 도출한 조건과 기존 분류 규칙을 대조한 기록입니다. 법률 조건의 값은 사용자가 직접 답한 값이 아닙니다.'
      : '현재 경로의 계산 기록입니다. 경쟁 경로는 각 소호를 가정해 평가하며, 가정한 소호는 사용자 확인 사실이 아닙니다. 미확인·충돌은 배제를 뜻하지 않습니다.'}</p>
    {tree?.derived_facts && <p>소호는 사용자가 고른 번호가 아니라, 확인된 상품 사실과 경쟁 경로 배제를 대조해 도출했습니다.</p>}
    {tree?.factual_question_limit && <p>남은 경쟁 경로를 가를 자동 질문이 부족합니다. 상품 설명서와 원문을 대조하는 추가 검토가 필요합니다.</p>}
    {rows.length > 0 && <ConditionRows rows={rows} />}
    {candidates.length > 0 && <details><summary>경쟁 경로 {candidates.length}개와 보류·배제 이유</summary>
      {candidates.map((candidate) => <details key={candidate.hs6} style={{ padding: 5 }}>
        <summary>{candidate.hs6} · {stateLabels[candidate.state] || "미확인"}</summary>
        <ConditionRows rows={Array.isArray(candidate.conditions) ? candidate.conditions : []} />
      </details>)}
    </details>}
    {(tree?.source_references || []).map((source, index) => <details key={index} style={{ marginTop: 6 }}>
      <summary>호·소호 원문: {source.title}</summary>
      {safeUrl(source.url) && <a href={safeUrl(source.url)} target="_blank" rel="noreferrer">공식 원문 열기</a>}
      <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: 12 }}>{source.excerpt}</pre>
    </details>)}
  </section>;
}
